import styled, { css } from 'styled-components';
import RTECompose from 'contentful/RTE_compose';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';

import ContentfulImageRenderer from './image_renderer';
import Container from './shared/container';
import Grid from './shared/grid';
import Carousel from './shared/carousel';

const CarouselSection = ({
  content: { images, title, content, columns = 3, backgroundColor },
  ...rest
}) =>
  images?.length > 0 && (
    <Container
      isFullWidth
      className="pos-r"
      backgroundColor={backgroundColor}
      {...rest}>
      <Grid cols={content ? 2 : 1} colGap={48} rowGap={48}>
        <ContentWrapper hasContent={!!content}>
          {title && <Title hasContent={!!content}>{title}</Title>}
          {content && (
            <Content>
              <RTECompose content={content} fieldType="content" />
            </Content>
          )}
        </ContentWrapper>

        <div>
          <Carousel
            slides={images.map(image => {
              const {
                sys: { id },
              } = image;

              return {
                content: <Image image={image} key={id} />,
              };
            })}
            columns={columns}
            isFullHeight={!!content}
          />
        </div>
      </Grid>
    </Container>
  );

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ hasContent }) =>
    hasContent
      ? css`
          ${responsive('tabletSmall')} {
            padding-block: ${toRem(56)};
          }
        `
      : css`
          text-align: center;
        `}
`;

const Title = styled.h2`
  font-size: ${toRem(32)};
  line-height: 1.25;
  margin-bottom: 0;

  ${({ hasContent }) =>
    hasContent &&
    css`
      margin-bottom: ${toRem(32)};

      ${responsive('tabletSmall')} {
        margin-bottom: ${toRem(40)};
      }
    `}
`;

const Content = styled.div`
  p {
    font-size: ${toRem(18)};
    line-height: 1.44;
  }

  ${responsive('tabletSmall')} {
    margin-bottom: ${toRem(48)};
  }
`;

const Image = styled(ContentfulImageRenderer)`
  height: auto;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  object-position: center;

  ${responsive('tabletLarge')} {
    height: 100%;
    max-height: 500px;
    width: fit-content;
  }
`;

export default CarouselSection;
